import { useEffect, useState } from "react";
import "./AccordionsStyles.css";
import { IFullPlanDetailPPO } from "../../interfaces/api";

import PPODataTableDetailDoctors from "./DataTableDetailsComponent/PPODataTableDetailDoctors.component";
import PPODataTableDetailOverview from "./DataTableDetailsComponent/PPODataTableDetailOverview.component";
import PPODataTableDetailDental from "./DataTableDetailsComponent/PPODataTableDetailDental.component";
import PPODataTableDetailVision from "./DataTableDetailsComponent/PPODataTableDetailVision.component";
import PPODataTableDetailHearing from "./DataTableDetailsComponent/PPODataTableDetailHearing.component";
import PPODataTableDetailMentalHealth from "./DataTableDetailsComponent/PPODataTableDetailMentalHealth.component";
import PPODataTableDetailSPrescriptions from "./DataTableDetailsComponent/PPODataTableDetailPrescriptions.component";
import PPODataTableDetailExtra from "./DataTableDetailsComponent/PPODataTableDetailExtraBenefits.component";
import PPOPCPSPECDataTableDetailDoctors from "./DataTableDetailsComponent/PPOPCPSPECDataTableDetailDoctors.component";
import PPODataTableSSCBI from "./DataTableDetailsComponent/PPODataTableDetailSSCBI.component";

const PPOAccordionDetails = ({
  data,
  allAccordionsOpen,
  setAnyAccordionOpen,
}: {
  data: IFullPlanDetailPPO;
  allAccordionsOpen: boolean;
  setAnyAccordionOpen: (isOpen: boolean) => void;
}) => {
  const [isOverviewOpen, setIsOverviewOpen] = useState(true);
  const [isDoctorsOpen, setIsDoctorsOpen] = useState(allAccordionsOpen);

  const [isHospitalOpen, setIsHospitalOpen] = useState(allAccordionsOpen);
  const [isDentalOpen, setIsDentalOpen] = useState(allAccordionsOpen);
  const [isVisionOpen, setIsVisionOpen] = useState(allAccordionsOpen);
  const [isHearingOpen, setIsHearingOpen] = useState(allAccordionsOpen);
  const [isMentalOpen, setIsMentalOpen] = useState(allAccordionsOpen);
  const [isAdditionalBenefits, setIsAdditionalBenefits] =
    useState(allAccordionsOpen);
  const [isPrescriptions, setIsPrescriptions] = useState(allAccordionsOpen);
  const [isSSBCI, setIsSSBCI] = useState(allAccordionsOpen);

  const handleOverviewOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsOverviewOpen(!isOverviewOpen);
  };
  const handleDoctorsOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDoctorsOpen(!isDoctorsOpen);
  };
  const handleHospitalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsHospitalOpen(!isHospitalOpen);
  };
  const handleDentalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDentalOpen(!isDentalOpen);
  };
  const handleVisionOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsVisionOpen(!isVisionOpen);
  };
  const handleHearingOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsHearingOpen(!isHearingOpen);
  };
  const handleMentalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsMentalOpen(!isMentalOpen);
  };
  const handleAdditionalBenefits = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsAdditionalBenefits(!isAdditionalBenefits);
  };
  const handlePrescriptionsBenefits = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setIsPrescriptions(!isPrescriptions);
  };
  const handleSSCBI = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsSSBCI(!isSSBCI);
  };

  useEffect(() => {
    setIsHospitalOpen(allAccordionsOpen);
    setIsDentalOpen(allAccordionsOpen);
    setIsVisionOpen(allAccordionsOpen);
    setIsHearingOpen(allAccordionsOpen);
    setIsMentalOpen(allAccordionsOpen);
    setIsAdditionalBenefits(allAccordionsOpen);
    setIsPrescriptions(allAccordionsOpen);
    setIsDoctorsOpen(allAccordionsOpen);
    setIsSSBCI(allAccordionsOpen);
  }, [allAccordionsOpen]);

  useEffect(() => {
    setAnyAccordionOpen(
      isOverviewOpen ||
        isHospitalOpen ||
        isDentalOpen ||
        isVisionOpen ||
        isHearingOpen ||
        isMentalOpen ||
        isAdditionalBenefits ||
        isPrescriptions ||
        isDoctorsOpen ||
        isSSBCI
    );
  }, [
    isAdditionalBenefits,
    isDentalOpen,
    isHearingOpen,
    isHospitalOpen,
    isMentalOpen,
    isOverviewOpen,
    isPrescriptions,
    isVisionOpen,
    isDoctorsOpen,
    setAnyAccordionOpen,
    isSSBCI,
  ]);

  return (
    <div className="grid-x align-center text-center margin-0">
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isOverviewOpen}
              onClick={handleOverviewOpen}
              aria-controls="accordion-content"
            >
              Overview
              <span id="accordion-button-sign">
                {isOverviewOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isOverviewOpen}
          role="region"
        >
          <PPODataTableDetailOverview data={data} ppo={true} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isDoctorsOpen}
              onClick={handleDoctorsOpen}
              aria-controls="accordion-content"
            >
              Doctors
              <span id="accordion-button-sign">
                {isDoctorsOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isDoctorsOpen}
          role="region"
        >
          <PPOPCPSPECDataTableDetailDoctors data={data} />
        </div>
      </section>

      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isHospitalOpen}
              onClick={handleHospitalOpen}
              aria-controls="accordion-content"
            >
              Hospital
              <span id="accordion-button-sign">
                {isHospitalOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isHospitalOpen}
          role="region"
        >
          <PPODataTableDetailDoctors data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isDentalOpen}
              onClick={handleDentalOpen}
              aria-controls="accordion-content"
            >
              Dental
              <span id="accordion-button-sign">
                {isDentalOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isDentalOpen}
          role="region"
        >
          <PPODataTableDetailDental data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isVisionOpen}
              onClick={handleVisionOpen}
              aria-controls="accordion-content"
            >
              Vision
              <span id="accordion-button-sign">
                {isVisionOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isVisionOpen}
          role="region"
        >
          <PPODataTableDetailVision data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isHearingOpen}
              onClick={handleHearingOpen}
              aria-controls="accordion-content"
            >
              Hearing
              <span id="accordion-button-sign">
                {isHearingOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isHearingOpen}
          role="region"
        >
          <PPODataTableDetailHearing data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isMentalOpen}
              onClick={handleMentalOpen}
              aria-controls="accordion-content"
            >
              Mental Health
              <span id="accordion-button-sign">
                {isMentalOpen ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isMentalOpen}
          role="region"
        >
          <PPODataTableDetailMentalHealth data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isPrescriptions}
              onClick={handlePrescriptionsBenefits}
              aria-controls="accordion-content"
            >
              Prescriptions
              <span id="accordion-button-sign">
                {isPrescriptions ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isPrescriptions}
          role="region"
        >
          <PPODataTableDetailSPrescriptions data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isAdditionalBenefits}
              onClick={handleAdditionalBenefits}
              aria-controls="accordion-content"
            >
              Additional Benefits
              <span id="accordion-button-sign">
                {isAdditionalBenefits ? "-" : "+"}{" "}
              </span>
            </button>
          </h2>
        </div>

        <div
          aria-labelledby="accordion-button"
          hidden={!isAdditionalBenefits}
          role="region"
        >
          <PPODataTableDetailExtra data={data} />
        </div>
      </section>
      <section className="accordion-container" style={{ marginBottom: 24 }}>
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isSSBCI}
              onClick={handleSSCBI}
              aria-controls="accordion-content"
            >
              Special Supplemental benefits for the chronically ill (SSBCI)
              <span id="accordion-button-sign">{isSSBCI ? "-" : "+"} </span>
            </button>
          </h2>
        </div>

        <div aria-labelledby="accordion-button" hidden={!isSSBCI} role="region">
          <PPODataTableSSCBI data={data} />
        </div>
      </section>
    </div>
  );
};

export default PPOAccordionDetails;
